export const DEFAULT_GUID = '00000000-0000-0000-0000-000000000000'

/**
 * Total number of days used in a payroll year.
 * 364 days = 52 full weeks (52 × 7).
 * We use 364 instead of 365 (or 366 depending on leap year)
 * to align with how most payroll systems calculate weekly pay.
 */
export const DAYS_IN_PAYROLL_YEAR = 364
